export default {
  computed: {
    ready () {
      return !this.$v.$invalid
    }
  },
  watch: {
    ready (val) {
      this.$emit('ready', val)
    }
  },
  mounted() {
    this.$emit('ready', this.ready)
  }
}
